import React, { useContext, useEffect, useState } from "react";
import { Grid, Divider, Alert } from "@mui/material";
import { Update, Summarize } from "@mui/icons-material";
import { handleDates } from "../../../Components/helpers/Helpers";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
import DatePicker from "../../../Components/Common/Inputs/DatePicker";
import Solicitud from "./InformesMedicosComponents/Solicitud";
import Notification from "./InformesMedicosComponents/Notification";
import UpdateCase from "./InformesMedicosComponents/UpdateCase";
import {
  DocsContext,
  PermissionContext,
} from "../../../Components/Context/Context";
import api from "../../../api/axios";

const StepsForm = ({
  mailTemplatesData,
  nextTask,
  caseId,
  dataCase,
  setUpdatedCase,
  updatedCase,
  activeFlow,
  activeTask,
  userLogged,
}) => {
  const { can } = useContext(PermissionContext);

  const Swal = require("sweetalert2");

  const { docsChangedFlag, setDocsChangedFlag, docsInfo } =
    useContext(DocsContext);

  const [revisionLimitDateInputFormat, setRevisionLimitDateInputFormat] =
    useState();

  const [message, setMessage] = useState(activeTask?.message);

  useEffect(() => {
    setMessage(activeTask?.message);
  }, [activeTask?.message]);

  const handleUpdateLimitDate = () => {
    const date = handleDates(revisionLimitDateInputFormat);
    console.log(date);

    if (date) {
      Swal.fire({
        title: "¡Cuidado!",
        html: "<div>Estás a punto de cambiar la fecha de vencimiento actual de la tarea.</div><br><div>¿Desea continuar?</div>",
        icon: "warning",
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        denyButtonText: "Volver",
        confirmButtonText: "Continuar",
        showDenyButton: true,
      }).then(async (response) => {
        if (response.isConfirmed) {
          console.log(caseId);
          console.log(date);
          console.log(dataCase?.task?.id);

          const formData = new FormData();
          formData.append("case_id", Number(caseId));
          formData.append("date_end", date);
          formData.append("id", Number(dataCase?.task?.id));

          const url = `${process.env.REACT_APP_API_URL}/cases/updatetaskdate`;

          try {
            const response = await api.post(url, formData);

            if (response) {
              Swal.fire({
                title: "Guardado",
                icon: "success",
                confirmButtonText: "Finalizar",
                confirmButtonColor: "#1ab394",
              });

              setUpdatedCase(!updatedCase);
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    } else {
      Swal.fire({
        html: "<div>Debe seleccionar una fecha diferente</div>",
        icon: "error",
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
        showDenyButton: false,
      });
    }
  };

  // console.log(activeFlow);

  const hidde =
    activeFlow?.order == dataCase?.completeFlow?.length ||
    (activeTask?.status != 1 && activeTask?.status != 0);
  const isntPreviousFlow = !(activeFlow?.order < dataCase?.flow?.order);
  const isCurrentFlow = activeFlow?.order === dataCase?.flow?.order;

  return hidde ? null : (
    <Grid container item xs={12}>
      {(isntPreviousFlow || isCurrentFlow) && can("cases", "edit") && (
        <Grid
          container
          item
          xs={12}
          sx={{
            border: "1px dashed #f4f9ff",
            backgroundColor: "#f4f9ff",
          }}>
          <Grid
            item
            xs={6}
            className="alignItemsAndLeft"
            sx={{ padding: "15px 10px" }}>
            {activeFlow?.status_name?.toLowerCase() == "juicio" ? (
              <b>ACTUALIZAR FECHA DE JUICIO:</b>
            ) : (
              <b>ACTUALIZAR FECHA DE FIN DE TAREA:</b>
            )}
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              padding: "15px 10px",
              justifyContent: "end",
              width: "100%",
              alignItems: "stretch",
              gap: 1,
              display: "flex",
            }}>
            <DatePicker
              text="Fecha de fin de tarea"
              date={dataCase?.task?.date_end}
              onChange={(newValue) => {
                setRevisionLimitDateInputFormat(newValue);
              }}
            />
            <CustomButtonPlusIcon
              // icon={Autorenew}
              icon={Update}
              handleFunction={handleUpdateLimitDate}
              variant={"outlined"}
            />
          </Grid>
        </Grid>
      )}

      <Grid item xs={12} py={"10px"}>
        <Divider width={"100%"} />
      </Grid>

      <Grid
        container
        direction="row"
        alignItems="stretch"
        justifyContent={"center"}>
        {message && (
          <Grid item xs={12}>
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </Grid>
        )}

        <Solicitud
          mailTemplatesData={mailTemplatesData}
          dataCase={dataCase}
          activeTask={activeTask}
          nextTask={nextTask}
          activeFlow={activeFlow}
          caseId={caseId}
          userLogged={userLogged}
          setUpdatedCase={setUpdatedCase}
          updatedCase={updatedCase}
          docsChangedFlag={docsChangedFlag}
          setDocsChangedFlag={setDocsChangedFlag}
        />
        <Grid
          item
          px={1}
          display="flex"
          alignItems="center"
          sx={{
            display: {
              xs: "none", //    oculto en xs
              sm: "none", //    oculto en sm
              md: "flex", //    oculto en md
              lg: "flex", //  visible en lg
              xl: "flex", //  visible en xl
            },
          }}>
          <Divider orientation="vertical" flexItem />
        </Grid>

        <Notification
          mailTemplatesData={mailTemplatesData}
          dataCase={dataCase}
          activeTask={activeTask}
          nextTask={nextTask}
          activeFlow={activeFlow}
          caseId={caseId}
          userLogged={userLogged}
          setUpdatedCase={setUpdatedCase}
          updatedCase={updatedCase}
          docsChangedFlag={docsChangedFlag}
          setDocsChangedFlag={setDocsChangedFlag}
        />
      </Grid>

      <Grid item xs={12} py={"10px"}>
        <Divider width={"100%"} />
      </Grid>

      {activeFlow.order == dataCase?.flow?.order && can("cases", "edit") && (
        <>
          <Grid item xs={12}>
            <Alert
              severity="success"
              icon={<Update />}
              sx={{ fontWeight: "700" }}>
              ACTUALIZAR
            </Alert>
          </Grid>
          <UpdateCase
            activeFlow={activeFlow}
            activeTask={activeTask}
            nextTask={nextTask}
            dataCase={dataCase}
          />
        </>
      )}
    </Grid>
  );
};

export default StepsForm;
